import res from './res'

res.add('en', {
    setPeriod: 'Set period'
})
